<template><svg xmlns="http://www.w3.org/2000/svg" width="40.5" height="23.579" viewBox="0 0 40.5 23.579">
    <g transform="translate(-232.583 -249.485)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <path d="M349.417,267.485H357s10.083.588,10.083,10.583-10.122,11.26-17.25,10.956C346.09,284.082,345.59,273.218,349.417,267.485Z"
              transform="translate(-95 -17)"/>
        <path d="M328.583,268.319h13.583" transform="translate(-95 -17)"/>
        <path d="M328.583,268.319h13.583" transform="translate(-95 -10.513)"/>
        <path d="M328.583,268.319h13.583" transform="translate(-95 -4.026)"/>
        <path d="M328.583,268.319h13.583" transform="translate(-95 2.461)"/>
    </g>
</svg>
</template>